import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2s3wgcdac: FaireProductEntity = {
  token: "p_r2s3wgcdac",
  type: "product",
  name: "DR. 14 Revitalizing Scalp Care Shampoo",
  brandToken: "b_107e5l5t3v",
  brandName: "LAPCOS",
  imageUrl:
    "https://cdn.faire.com/fastly/ada35b028fd54b3ef316298779180a5af63ec9bf97c7ab2f6e4b5a22844cbfc5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75a25708bbfb4754a3526688ddbc40bf203f411fedc7a755be5f612f7c4daa42.jpeg",
    "https://cdn.faire.com/fastly/afbe94a99cc2c1edfa866282eed5b4ec34f5aaaa7e64e9143aeaa90bed804292.jpeg",
    "https://cdn.faire.com/fastly/03bb5dcddf3fe01ec5d139fa4fd6e65c9ab2586e017d12317aa06b8aa396e9d1.jpeg",
    "https://cdn.faire.com/fastly/013910cf09606d7d5157f8a28079b144734a25844fc0cc5cd3a6a4818c5c3878.jpeg",
    "https://cdn.faire.com/fastly/4ca2ce6304a74e2e6a49438b5a564f02da096b0add43cb5415a7d244e76ddace.jpeg",
    "https://cdn.faire.com/fastly/9b7a4580b3e64090cd281456e97a0a6f5be5ff35ab046a4d51b324aae706e59d.jpeg",
    "https://cdn.faire.com/fastly/428177d4da1a5747ae50444b43d8475d3e7955d6b35310ef68717ffe2ff66ef0.jpeg",
  ],
  priceDollars: 14.9,
  description:
    "(Minimum Order: 8 pks) **You must place the minimum order indicated, if you change the quantity to a number below specified amount we will adjust on our end to match the correct minimum**\n\nK-BEAUTY Scalp care focused shampoo | Our holy grail, bestselling Dr. 14 Scalp Care Shampoo is back and better than ever with a new look and refreshed, vegan formulation! Made with 14 high performing active ingredients, Dr. 14 is a daily shampoo and hair thickening scalp treatment proven to target multiple underlying factors of hair health.\n\nHero Ingredients\n\n1) Salicylic Acid: Defends against seborrheic dermatitis&nbsp;\n\n2) Coconut Oil: Helps prevent skin irritation and restore luster\n\n3) Soybean: Naturally effective in repairing hair follicles\n\n4) Biotin: Supports a healthy scalp, by protecting against seborrheic dermatitis\n\n5) Spearmint: Provides a revitalizing, cooling sensation\n\n6) Squalane: Replenishes moisture to hair strands\n\n+ Improves texture & sheen\n\n+ Promotes hair growth, volume and fullness",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:16.232Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
